<template>
  <section class="hero-section section-v2">
    <div class="container">
      <div class="row">
        <div class="col col-12">
          <h1 class="hero-title">
            <span class="single-line">Free online </span>
            <span class="highlight">statistics calculators</span> & <span class="gray">statistical tables</span>
          </h1>
          <p class="hero-description">
            Effortlessly calculate confidence intervals, means, standard deviations, p-values, and more—powered by 365.
          </p>
          <div class="checks">
            <div v-for="(check,i) in checks" :key="i" class="check">
              <IconCheck />
              <span class="check-text">
                {{ check }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import IconCheck from '@itbpbg/lms-components/src/assets/svg/icon-check-with-background.svg?vue-component';

export default {
  components: {
    IconCheck,
  },
  data() {
    return {
      checks: [
        'Free',
        'Instant results',
        'Guided walkthroughs',
      ],
    };
  },
};
</script>

<style scoped lang="scss">
.hero-section {
  .container .col-12 {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .hero-title {
    text-align: center;
    font-size: 52px;

    .single-line {
      display: inline-block;
      width: 100%;
    }

    .highlight, .gray {
      font-weight: 700;
    }

    .highlight {
      color: var(--accent-shade-1);
    }

    .gray {
      color: var(--main-dark-light-4);
    }
  }

  .hero-description {
    color: var(--main-dark-shade-2);
    text-align: center;
    font-size: 21px;
    line-height: 110%;
    margin-top: 0;
    margin-bottom: 16px;
  }

  .checks {
    width: 770px;
    max-width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 16px;

    .check {
      display: flex;
      align-items: center;
      font-size: 21px;
      line-height: 110%;

      > svg {
        width: 21px;
        height: 20px;
        margin-right: 8px;
      }
    }
  }
}

@include bp($bp-laptop-tablet) {
  .hero-section {
    .hero-title {
      font-size: 48px;
    }
  }
}

@include bp($bp-mobile) {
  .hero-section {
    .hero-title {
      font-size: 40px;
    }

    .hero-description {
      font-size: 18px;
    }

    .checks {
      grid-template-columns: 1fr;
      gap: 8px;
    }
  }
}
</style>
